import React from 'react';
import Select from '../../../components/ui/Select';

import { Checkbox } from '../../../components/ui/Checkbox';

const DisplayPreferencesTab = ({ settings, onSettingChange }) => {
  const currencyOptions = [
    { value: 'USD', label: 'US Dollar ($)' },
    { value: 'EUR', label: 'Euro (€)' },
    { value: 'GBP', label: 'British Pound (£)' },
    { value: 'CAD', label: 'Canadian Dollar (C$)' },
    { value: 'AUD', label: 'Australian Dollar (A$)' }
  ];

  const dateFormatOptions = [
    { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY (US Format)' },
    { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY (International)' },
    { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD (ISO Format)' }
  ];

  const decimalOptions = [
    { value: '0', label: 'No decimals (1,000)' },
    { value: '2', label: '2 decimals (1,000.00)' },
    { value: '4', label: '4 decimals (1,000.0000)' }
  ];

  const thousandsSeparatorOptions = [
    { value: ',', label: 'Comma (1,000.00)' },
    { value: '.', label: 'Period (1.000,00)' },
    { value: ' ', label: 'Space (1 000.00)' },
    { value: '', label: 'None (1000.00)' }
  ];

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4">Currency & Number Formatting</h3>
        <p className="text-sm text-text-secondary mb-6">Customize how monetary values and numbers are displayed throughout the application.</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Select
            label="Currency Format"
            options={currencyOptions}
            value={settings.currencyFormat}
            onChange={(value) => onSettingChange('currencyFormat', value)}
            description="Primary currency for all calculations"
          />
          
          <Select
            label="Decimal Precision"
            options={decimalOptions}
            value={settings.decimalPrecision}
            onChange={(value) => onSettingChange('decimalPrecision', value)}
            description="Number of decimal places to display"
          />
          
          <Select
            label="Thousands Separator"
            options={thousandsSeparatorOptions}
            value={settings.thousandsSeparator}
            onChange={(value) => onSettingChange('thousandsSeparator', value)}
            description="Character used to separate thousands"
          />
          
          <Select
            label="Date Format"
            options={dateFormatOptions}
            value={settings.dateFormat}
            onChange={(value) => onSettingChange('dateFormat', value)}
            description="Date display format for payment schedules"
          />
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4">Table Display Options</h3>
        <p className="text-sm text-text-secondary mb-6">Configure how the amortization schedule table appears and behaves.</p>
        
        <div className="space-y-4">
          <Checkbox
            label="Show Payment Numbers"
            checked={settings.showPaymentNumbers}
            onChange={(e) => onSettingChange('showPaymentNumbers', e.target.checked)}
            description="Display sequential payment numbers in the first column"
          />
          
          <Checkbox
            label="Show Year Indicators"
            checked={settings.showYearIndicators}
            onChange={(e) => onSettingChange('showYearIndicators', e.target.checked)}
            description="Add year markers to identify payment years"
          />
          
          <Checkbox
            label="Highlight Yearly Totals"
            checked={settings.highlightYearlyTotals}
            onChange={(e) => onSettingChange('highlightYearlyTotals', e.target.checked)}
            description="Use distinct styling for yearly summary rows"
          />
          
          <Checkbox
            label="Alternating Row Colors"
            checked={settings.alternatingRowColors}
            onChange={(e) => onSettingChange('alternatingRowColors', e.target.checked)}
            description="Use zebra striping for better table readability"
          />
          
          <Checkbox
            label="Show Running Balance"
            checked={settings.showRunningBalance}
            onChange={(e) => onSettingChange('showRunningBalance', e.target.checked)}
            description="Display remaining balance after each payment"
          />
          
          <Checkbox
            label="Show Cumulative Interest"
            checked={settings.showCumulativeInterest}
            onChange={(e) => onSettingChange('showCumulativeInterest', e.target.checked)}
            description="Track total interest paid to date"
          />
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4">Chart Preferences</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Checkbox
            label="Show Payment Breakdown Chart"
            checked={settings.showPaymentChart}
            onChange={(e) => onSettingChange('showPaymentChart', e.target.checked)}
            description="Display visual breakdown of principal vs interest"
          />
          
          <Checkbox
            label="Show Balance Over Time"
            checked={settings.showBalanceChart}
            onChange={(e) => onSettingChange('showBalanceChart', e.target.checked)}
            description="Graph showing loan balance reduction over time"
          />
        </div>
      </div>
    </div>
  );
};

export default DisplayPreferencesTab;